module.exports = __webpack_public_path__ + "img/icon-movie.8171b7d7.svg";